/**
 * CORE-746 — is the *current* authenticated user a «Путь света» participant?
 *
 * Thin wrapper over the central rule in utils/gamificationEligibility. It reads
 * the live Master role from AuthContext, so revoking/granting the role takes
 * effect after refreshUser() (i.e. the next /api/auth/me) without a re-login.
 */
import { useAuth } from '../context/AuthContext';
import { isUserGamificationParticipant } from '../utils/gamificationEligibility';

export function useIsGamificationParticipant(): boolean {
  const { hasRole } = useAuth();
  return isUserGamificationParticipant(hasRole('Master'));
}
